import React from "react";
import * as R from "fp-ts/Record";
import { pipe } from "fp-ts/function";
import * as O from "fp-ts/Option";

import { Separator } from "src/components/separator/separator";
import { Body, PageTitle, SectionTitle } from "src/components/typography/typography";
import { DomainsCircle } from "../../graphics/domains_circle";
import { BarChart } from "../../../../../../components/charts/bar_chart";
import { BarData } from "../../../../../../components/charts/bar";

import { meta } from "./meta";

/*
 * Types
 */

export type HandsProps = {
    readonly reports: Array<any>;
};

/*
 * Main
 */

export const Hands = (props: HandsProps): React.ReactElement => {
    const { reports } = props;

    const data = reports.flatMap((report) => {
        return R.keys(report.node.results.raw.hands).map((construct) => {
            const item = R.lookup(construct, meta);
            return pipe(
                item,
                O.match(
                    () => ({
                        label: "",
                        value: 0,
                    }),
                    (item: Opportunity): BarData => ({
                        label: `${report.node.year} ${item.title}`,
                        value: report.node.results.raw.hands[construct],
                    }),
                ),
            );
        });
    });

    return (
        <div className="main-report-content-wrap">
            <div className="single-domain-result-top-wrap">
                <DomainsCircle activeDomain="hands" inline />
                <PageTitle style={{ color: "#99b84e" }}>Hands</PageTitle>
                <Body>
                    Like the 25-item propositional survey, the Hands domain does not contain any validated constructs,
                    but rather ten spiritual disciplines asked across the seven constituent groups. Best practice in
                    survey design is not to ask respondents how they feel about a particular item (unavoidable for any
                    measure of Heart), but rather how often they engage in particular behaviors. Items and scores for
                    the five student items are below.
                </Body>
                <Body>
                    For “Hands” items: <br />
                    <br />
                    1 = Never <br />
                    2 = Yearly (or less frequently) <br />
                    3 = Several times a year <br />
                    4 = Monthly <br />
                    5 = Several times a month <br />
                    6 = Weekly <br />
                    7 = Several times a week <br />
                    8 = Daily <br />9 = Several times a day
                </Body>
                <Separator />
            </div>
            <div className="an-opportunity-item domain-result">
                <SectionTitle style={{ color: "#99b84e" }}>
                    Frequency of Spiritual Disciplines: Student Responses
                </SectionTitle>
                <BarChart backgroundColor="#DEEBBD" data={data} isRaw={true} labelPosition="top" maxValue={9} />
            </div>
        </div>
    );
};
